import React, { FC } from 'react';
import { isMobileChannel } from '../util';
import RouteLink from '../routing/RouteLink';
import { N1_MATCH_DETAIL } from '../routing';
import { NikeCakeCms } from '../../types/generated/cake-cms';

export const getClassNameByBet = bet => {
    if (bet.get('closeOdds')) {
        return 'Closed';
    }
    return bet.get('status');
};

const validSportData = (sportData: any): boolean =>
    sportData !== null && typeof sportData === 'object' && Array.isArray(sportData.sports);

export const LinkToPrematchDetail: FC<{ matchId: string }> = ({ matchId, children }) => {
    return isMobileChannel() ? (
        <RouteLink routePath={N1_MATCH_DETAIL} params={{ eventId: matchId }}>
            {children}
        </RouteLink>
    ) : (
        <a href={`/tipovanie/zapas/${matchId}`}>{children}</a>
    );
};

// default - 'alpske-lyzovanie'
// useDashFormat false - 'alpskelyzovanie'
export const getSportNameById = (id: number | string, useDashFormat: boolean = true): string | null => {
    const sportsData: NikeCakeCms.Sports = window.OPTIONS?.sportsData;
    const numericId = typeof id === 'number' ? id : parseInt(id, 10);

    if (validSportData(sportsData) && !isNaN(numericId)) {
        // sport_icon_id = slug without slash
        const sportName = sportsData.sports.find(sport => sport.sport_id === numericId)?.sport_icon_id;
        if (sportName) return useDashFormat ? sportName : sportName.replace(/-/g, '');
    }

    return null;
};

export const getSportIdByName = (name: string): string | null => {
    const sportsData: NikeCakeCms.Sports = window.OPTIONS?.sportsData;

    if (validSportData(sportsData) && name)
        return sportsData.sports
            .find(sport => sport.sport_icon_id === name || sport.sport_icon_id.replace(/-/g, '') === name)
            ?.sport_id.toString();

    return null;
};
